module.exports = __webpack_public_path__ + "img/bg_2.4c50f3e.png";